import InteractionsMenu from './InteractionsMenu-redux';

export default InteractionsMenu;
